import React, { Component } from 'react';
import { Grid } from 'react-md';
import { NavLink, withRouter } from 'react-router-dom';

import './FooterNav.css';

class FooterNav extends Component {
	render() {
		const currentPathname = this.props.location.pathname;
		let foundCurrentPath = false;

		const buttons = [
			{
				name: 'Welcome',
				path: '/'
			},
			{
				name: 'Info',
				path: '/info'
			},
			{
				name: 'Estimate',
				path: '/estimate'
			},
			{
				name: 'Contacts',
				path: '/contacts'
			},
			{
				name: 'Upload',
				path: '/upload'
			}
		].map((button, index) => {
			const navLinkClassesArray = ['nav-link'];

			if (currentPathname === button.path) {
				foundCurrentPath = true;
			}

			if (foundCurrentPath === true) {
				navLinkClassesArray.push('disabled');
			}

			const navLinkClasses = navLinkClassesArray.join(' ');

			return (
				<NavLink
					key={index}
					exact
					to={button.path}
					className={navLinkClasses}
					activeClassName="active"
				>
					<span className="number">{index + 1}</span>
					<span className="name">{button.name}</span>
				</NavLink>
			);
		});

		return <Grid className="FooterNav">{buttons}</Grid>;
	}
}

export default withRouter(FooterNav);



// WEBPACK FOOTER //
// ./src/components/FooterNav.js